export function getItemId(): string {
    const re = /\/checkout\/id-(\w+)[/]?/;
    const result = re.exec(document.location.pathname);
    return (result && result[1]) || '';
}
